import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { map, } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ELearningManagementService } from '../e-learning-management.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-review-management',
  templateUrl: './review-management.component.html',
  styleUrls: ['./review-management.component.scss']
})
export class ReviewManagementComponent implements OnInit {

  courseId: string;
  courseName: string;
  // course;
  allReviewDetail;
  total_review: number;
  max_point: number;
  average_point: number;
  listReview;
  allReview;
  isReadMore = true;
  point;

  constructor(
    public matDialog: MatDialog,
    private eLearningService: ELearningManagementService,
    private gobalFunctionService: GobalFunctionService

  ) { }

  ngOnInit(): void {
    this.courseId = new URL(location.href).searchParams.get('course_id');
    this.gobalFunctionService.setTitle('การจัดการรีวิว');

    this.eLearningService.getAllReviewByCourseId(this.courseId).pipe(
      map(listReview => {
        this.listReview = listReview.result;
        this.allReview = listReview.result.REVIEW_LIST;
        this.point = listReview.result.POINT;
        // console.log(listReview);
      })
    ).subscribe();
  }

  delete(reviewId, reviewMessage) {
    // console.log(reviewId, reviewMessage);
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalDeleteReview';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'คุณต้องการลบความคิดเห็น?',
      description: `"${reviewMessage}"`,
      actionBtnText: 'ลบ',
      cancleBtnText: 'ย้อนกลับ',
      isDelete: true
    }

    const formDialog = this.matDialog.open(ModalComponent, dialogConfig);
    formDialog.afterClosed().subscribe(isDelete => {
      if (isDelete) {
        this.eLearningService.delReviewById(reviewId).subscribe(res => {
          // console.log(res);
          if (res.success) {
            dialogConfig.disableClose = true;
            dialogConfig.id = 'modalConfirm';
            dialogConfig.width = '350px';
            dialogConfig.data = {
              title: 'ลบความคิดเห็น',
              description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ลบความคิดเห็นสำเร็จแล้ว`,
              cancleBtnText: 'ยืนยัน',
              customStyle: 'background-color: #58595B;'
            }
          }

          const modal = this.matDialog.open(ModalComponent, dialogConfig);
          modal.afterClosed().subscribe(res => {
            if (!res) {
              window.opener.location.reload();
              setTimeout(() => {
                // window.close()
                location.reload();
              }, 100);
            }
          })
        })
      }
    })
  }

}
